var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer'),(_vm.onProgress)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('modal-agree'),_c('dashboard-core-view'),_c('dashboard-core-settings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }